import api from "@/store/api";
import { isIOS, isWeb } from "@/utils/platform.util";

enum IntegrationServiceSource {
  Android = "ANDROID",
  iOS = "IOS",
  MyEquip = "MY-EQUIP",
}

interface IntercomAPITokenResponse {
  expiresAt: string;
  token: string;
}

interface BrazeSDKAuthenticationSignatureResponse {
  expiresIn: number;
  token: string;
}

const Platform = (() => {
  if (isWeb()) return IntegrationServiceSource.MyEquip;
  if (isIOS()) return IntegrationServiceSource.iOS;
  return IntegrationServiceSource.Android;
})();

const integrationServiceApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBrazeSDKAuthenticationSignature: build.query<
      BrazeSDKAuthenticationSignatureResponse,
      void
    >({
      // Never cache - always fetch fresh token to prevent JWT_EXPIRED errors
      keepUnusedDataFor: 0,
      query: () => ({
        method: "GET",
        params: { source: Platform },
        url: "/integration-service/family/braze/token",
      }),
    }),
    getIntercomToken: build.query<IntercomAPITokenResponse, void>({
      query: () => {
        return {
          method: "GET",
          params: { source: Platform },
          url: "/integration-service/family/intercom/token",
        };
      },
    }),
  }),
});

const {
  useLazyGetBrazeSDKAuthenticationSignatureQuery,
  useLazyGetIntercomTokenQuery,
} = integrationServiceApi;

export {
  useLazyGetBrazeSDKAuthenticationSignatureQuery,
  useLazyGetIntercomTokenQuery,
};
